"use client";

import type { LucideIcon } from "lucide-react";
import { ChartColumn, MapPin, Users } from "lucide-react";
import { Stagger, StaggerItem } from "@/components/motion/Stagger";
import type { ProgramStat } from "@/content/programs/types";
import { cn } from "@/lib/utils";

const STAT_ICONS: LucideIcon[] = [ChartColumn, Users, MapPin];

interface ProgramStatsBarProps {
  stats: ProgramStat[];
  className?: string;
}

export function ProgramStatsBar({ stats, className }: ProgramStatsBarProps) {
  if (stats.length === 0) return null;

  const gridCols =
    stats.length === 4
      ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-4"
      : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3";

  return (
    <div className={cn("hero-stats-bar w-full", className)}>
      <Stagger className={cn("hero-stats-bar-inner grid", gridCols)}>
        {stats.map((stat, index) => {
          const Icon = STAT_ICONS[index % STAT_ICONS.length];

          return (
            <StaggerItem key={stat.label}>
              <div
                className={cn(
                  "hero-stats-bar-cell flex items-center gap-3",
                  index > 0 && "md:border-l md:border-white/15"
                )}
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/10 text-[var(--charity-gold)]">
                  <Icon size={18} aria-hidden />
                </span>
                <div className="min-w-0 text-left">
                  <p className="break-words text-sm font-bold leading-tight text-[var(--charity-gold)] sm:text-base md:text-lg">
                    {stat.value}
                  </p>
                  <p className="mt-0.5 text-xs leading-tight text-white/85">
                    {stat.label}
                  </p>
                </div>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  );
}
